module.exports = __webpack_public_path__ + "about-planting.jpg?71c637c561f3769c1b0b4fb8126b22c6";


//////////////////
// WEBPACK FOOTER
// ./src/images/about-planting.jpg
// module id = 152
// module chunks = 0